import styled from "styled-components";
import Link from "next/link";

import { BREAKPOINT, COLORS } from "../../constants/Styles";

const Footer = styled.footer`
  margin-top: 1rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  color: ${COLORS.secondaryLight};
  flex-wrap: wrap;

  @media (max-width: ${BREAKPOINT}) {
    align-items: flex-start;
    flex-direction: column;
    flex-wrap: nowrap;
  }

  > * {
    padding: 1rem;
    margin: 0 1rem;
  }

  @media print {
    display: none;
    position: static;
  }
`;

const TextArea = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
  max-height: 3rem;

  > span {
    filter: brightness(60%);
    margin-right: 0.5rem;
  }
`;

const TextLink = styled(Link)`
  color: ${COLORS.secondaryLight};
  text-decoration: none;

  &:hover {
    color: ${COLORS.secondary};
  }
`;

export { Footer, TextArea, TextLink };
